import Router from 'vue-router'

import * as pages from '@/pages'
import * as layouts from '@/layouts'


const routes = [
  {
    path: '/',
    component: layouts.default,
    children: [
      {
        path: '/',
        name: 'HomePage',
        component: pages.dashboard.home,
      },
    ]
  }
];
const router = new Router({routes, mode: 'history', base: '/'});

export default router
